import React, { useRef } from 'react';
import { FaMapMarkerAlt, FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import officeImage from '../assets/images/office.jpg';
import '../styles/ContactPage.css';

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic here
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-info">
          <h1>Contact Us</h1>
          
          <div className="info-card">
            <FaMapMarkerAlt className="info-icon" />
            <h3>Visit Our Office</h3>
            <p>1305 S 312th St suite 202<br />Federal Way, WA 98003</p>
          </div>
          
          <div className="info-card">
            <FaPhone className="info-icon" />
            <h3>Call Us</h3>
            <p><a href="tel:2065664676">(206) 566-4676</a></p>
          </div>
          
          <div className="info-card">
            <FaWhatsapp className="info-icon" />
            <h3>WhatsApp</h3>
            <p><a href="https://wa.me/12065664676">Message Now</a></p>
          </div>
          
          <div className="info-card">
            <FaEnvelope className="info-icon" />
            <h3>Email</h3>
            <p><a href="mailto:info@notarypublic.com">info@notarypublic.com</a></p>
          </div>
        </div>
        
        <div className="contact-form-section">
          <img src={officeImage} alt="Our Office" className="office-image" />
          <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
            <h2>Send a Message</h2>
            <div className="form-group">
              <input type="text" placeholder="Your Name" required />
            </div>
            <div className="form-group">
              <input type="email" placeholder="Email Address" required />
            </div>
            <div className="form-group">
              <input type="tel" placeholder="Phone Number" />
            </div>
            <div className="form-group">
              <textarea placeholder="Your Message" rows="5" required></textarea>
            </div>
            <button type="submit" className="submit-button">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;